import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "input"];

  submit() {
    this.element.requestSubmit();
  }
}
